import { useTranslation } from "react-i18next";
import { Home } from "lucide-react";

interface PropertiesListEmptyProps {
  readonly hasFilters: boolean;
}

export function PropertiesListEmpty({ hasFilters }: PropertiesListEmptyProps) {
  const { t } = useTranslation();
  return (
    <div
      data-testid={hasFilters ? "properties-list-no-results" : "properties-list-empty"}
      className="rounded-lg border border-dashed border-border bg-card p-10 text-center"
    >
      <Home className="mx-auto mb-3 h-8 w-8 text-muted-foreground" aria-hidden="true" />
      <p className="font-sans text-base font-medium text-foreground">
        {hasFilters ? t("properties.empty.filteredTitle") : t("properties.empty.title")}
      </p>
      <p className="mt-1 font-sans text-sm font-normal text-muted-foreground">
        {hasFilters ? t("properties.empty.filteredBody") : t("properties.empty.body")}
      </p>
    </div>
  );
}
